import { HttpClient } from '@angular/common/http';
import { Component, AfterViewInit } from '@angular/core';
import { set } from 'lodash';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-modal-pop-up',
  standalone: true,
  imports: [NgxSpinnerModule],
  templateUrl: './modal-pop-up.component.html',
  styleUrl: './modal-pop-up.component.css'
})
export class ModalPopUpComponent implements AfterViewInit {
  listImages: any;
  activePromotion: any = {};

  constructor(private spinner: NgxSpinnerService, private http: HttpClient,) {
    
  }

  async ngAfterViewInit() {
    this.listImages = await this.getImages().then(data => {
      this.listImages = data;
      this.activePromotion = this.listImages[0];

      if(this.activePromotion){
        console.log(this.activePromotion.url);

        this.openModal();
      }
      setTimeout(() => {
        this.closeModal();
      }, 5000);
    })
    
  }

  openModal() {
    if (typeof document === 'undefined') {
      return;
    }
    const modal = document.getElementById('myModal') as HTMLDialogElement;
    modal?.showModal();
  }

  closeModal() {
    if (typeof document === 'undefined') {
      return;
    }
    const modal = document.getElementById('myModal') as HTMLDialogElement;
    modal?.close();
  }

  async getImages() {
    this.spinner.show();
    try {
      const data = await this.http
        .get<any>('https://mundoev.com/index.php?fc=module&module=popupimagemanager&controller=api')
        .toPromise();
      return data.images || [];
    } catch (error) {
      console.error('There was an error!', error);
      return [];
    } finally {
      this.spinner.hide();
    }
  }

}
